import React from "react"
import clsx from "clsx"
import {NavLink, Outlet} from "react-router-dom"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {IconName} from "@fortawesome/pro-regular-svg-icons"

import {GameCreate, GameEdit, GameList, GameStats, Preview} from "@modules/game/containers/admin"
import {LabelSetCreate, LabelSetList} from "@modules/label/containers/admin"
import {UserEdit, UserList, UserStats} from "@modules/user/containers/admin"
import {Create as GroupCreate, GroupStats, List as GroupList} from "@modules/group/containers/admin"
import {GamePlayDetails, GamePlayList} from "@modules/gamePlay/containers/admin"


export const adminRoutes = [
    {
        title: "Game Plays",
        path: "gamePlays",
        handle: {
            icon: ["far", "analytics"]
        },
        children: [
            {
                index: true,
                element: <GamePlayList/>
            },
            {
                path: ":gamePlayId",
                element: <GamePlayDetails/>
            }
        ]
    },
    {
        title: "Games",
        path: "games",
        handle: {
            icon: ["far", "game-board"]
        },
        children: [
            {
                index: true,
                element: <GameList/>
            },
            {
                path: "create",
                element: <GameCreate/>
            },
            {
                path: ":gameId",
                element: <GameEdit/>
            },
            {
                path: ":gameId/preview",
                element: <Preview/>
            },
            {
                path: ":gameId/stats",
                element: <GameStats/>
            }
        ]
    },
    {
        title: "Label Sets",
        path: "labelSets",
        handle: {
            icon: ["far", "tag"]
        },
        children: [
            {
                index: true,
                element: <LabelSetList/>
            },
            {
                path: "create",
                element: <LabelSetCreate/>
            },
            {
                path: ":labelId",
                element: <LabelSetCreate/>
            },
        ]
    },
    {
        title: "Users",
        path: "users",
        handle: {
            icon: ["far", "user"]
        },
        children: [
            {
                index: true,
                element: <UserList/>
            },
            {
                path: "stats/:userID",
                element: <UserStats/>
            },
            {
                path: ":userId",
                element: <UserEdit/>
            },
        ]
    },
    {
        title: "Groups",
        path: "groups",
        handle: {
            icon: ["far", "users"]
        },
        children: [
            {
                index: true,
                element: <GroupList/>
            },
            {
                path: "create",
                element: <GroupCreate/>
            },
            {
                path: "stats/:groupId",
                element: <GroupStats/>
            },
            {
                path: ":groupId",
                element: <GroupCreate/>
            },
        ]

    },
    // {
    //     title: "Settings",
    //     path: "settings",
    //     handle: {
    //         icon: ["far", "cog"]
    //     },
    //     element: <div>site settings</div>,
    // },
]

export default function AdminPanel() {

    return <div className="lg:flex lg:gap-x-8">
        <aside
            className="flex overflow-x-auto border-b border-gray-900/5 lg:block lg:w-64 lg:flex-none lg:border-0">
            <nav className="bg-white rounded-lg shadow flex-none px-4 sm:px-6 lg:px-0">
                <ul role="list" className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
                    {adminRoutes.map((item) => (
                        <li key={item.title}>
                            <NavLink
                                to={item.path}
                                end={!item.children}
                                className={({isActive}) => clsx(
                                    isActive
                                        ? "bg-gray-50 text-indigo-600"
                                        : "text-gray-700 hover:text-indigo-600 hover:bg-gray-50",
                                    "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm leading-6 font-semibold"
                                )}
                            >
                                {({isActive}) => (
                                    <div className="flex items-center space-x-2">
                                        <FontAwesomeIcon
                                            icon={item.handle?.icon as unknown as IconName || ["far", "circle"]}
                                            fixedWidth
                                            size="1x"
                                            className={clsx(
                                                isActive ? "text-indigo-600" : "text-gray-400 group-hover:text-indigo-600"
                                            )}
                                        />
                                        {/*<item.icon*/}
                                        {/*    className={clsx(*/}
                                        {/*        isActive ? "text-indigo-600" : "text-gray-400 group-hover:text-indigo-600",*/}
                                        {/*        "h-6 w-6 shrink-0"*/}
                                        {/*    )}*/}
                                        {/*    aria-hidden="true"*/}
                                        {/*/>*/}
                                        <span>{item.title}</span>
                                    </div>
                                )}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
        <div className="w-full">
            <Outlet/>
        </div>
    </div>
}

